// Arquivo: src/components/Sidebar/Sidebar.js

import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import * as S from "./SidebarStyles";
import assets from "../../assets/assets";
import { AuthContext } from "../../context/AuthContext";
import ProfilePage from "../UserPage/UserPage";

// Importando os ícones
import {
  FaHome,
  FaShoppingCart,
  FaUniversity,
  FaNewspaper,
  FaFileInvoice,
  FaChartLine,
  FaChartBar,
  FaSignOutAlt,
  FaGem,
  FaGift, 
} from "react-icons/fa";

export const Sidebar = ({ isOpen }) => {
  const { userData, logout } = useContext(AuthContext);
  const [fotoPerfil, setFotoPerfil] = useState(assets.user3);
  const [profilePage, setProfilePage] = useState(false);
  const location = useLocation();

  const blockedUserIds = [18992, 15113, 19127, 17140, 16758, 16949, 15225, 18727, 18665, 18859, 19103, 15227, 19143, 17423, 18149, 19170, 19232, 18510, 13317];

  const handleLogOut = () => {
    logout();
  };

  function obterPrimeiroNome(nomeCompleto) {
    if (!nomeCompleto) return "";
    return nomeCompleto.split(" ")[0];
  }

  const navItems = [
    { path: "/dashboard", label: "HOME", icon: <FaHome /> },
    { path: "/novacompra", label: "NOVA COMPRA (C.M.)", icon: <FaShoppingCart /> },
    { path: "/caixinha", label: "GOLDEN BOX", icon: <FaGift /> },
    { path: "/saque", label: "SAQUES (C.M.)", icon: <FaUniversity /> },
    { path: "/noticias", label: "NOTÍCIAS", icon: <FaNewspaper /> },
    { path: "/extrato", label: "EXTRATO DA CONTA", icon: <FaFileInvoice /> },
    {
      path: "/extratovalorizacao",
      label: "EXTRATO DE VALORIZAÇÃO (C.M.)",
      icon: <FaChartLine />,
    },
    { path: "/relatorio", label: "RELATÓRIO DE VAL. (C.M.)", icon: <FaChartBar /> },
  ];

  const filteredNavItems = navItems.filter((item) => {
    if (item.label === "GOLDEN BOX") {
      return !blockedUserIds.includes(userData?.id);
    }
    return true;
  });


  return (
    <>
      {profilePage && <ProfilePage setProfilePage={setProfilePage} />}

      <S.Container className={isOpen ? "open" : "closed"}>
        <S.LogoBox>
          <img src="logo-golden.png" alt="Golden Brasil Logo" />
          <span>GOLDEN BRASIL</span>
        </S.LogoBox>

        {/* A lista de links agora é o elemento que vai rolar */}
        <S.Mapper>
          {filteredNavItems.map((item) => (
            <Link to={item.path} key={item.label}>
              <S.NavItem
                className={location.pathname === item.path ? "active" : ""}
              >
                <S.NavLink>
                  <S.IconWrapper>{item.icon}</S.IconWrapper>
                  {item.label}
                </S.NavLink>
              </S.NavItem>
            </Link>
          ))}
        </S.Mapper>

        {/* Seção inferior fica fixa no final */}
        <S.BottomSection>
          <Link onClick={handleLogOut}>
            <S.NavItem className="logout-link">
              <S.NavLink>
                <S.IconWrapper>
                  <FaSignOutAlt />
                </S.IconWrapper>
                SAIR
              </S.NavLink>
            </S.NavItem>
          </Link>
          <S.Footer onClick={() => setProfilePage(true)}>
            <S.UserAvatar>
              <img src={fotoPerfil} alt="Foto do perfil" />
            </S.UserAvatar>
            <S.UserInfo>
              <p className="username">
                {userData && obterPrimeiroNome(userData.name)}
              </p>
              <p className="view-profile">Ver Perfil</p>
            </S.UserInfo>
          </S.Footer>
        </S.BottomSection>
      </S.Container>
    </>
  );
};
